module.exports = __webpack_public_path__ + "static/media/poppins-600.8f07cdf2.ttf";